(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["audere-collection"]) return;
  try {
    
  document.querySelectorAll('[data-audere-collection]').forEach((root) => {
    if (root.dataset.collectionInitialized === 'true') return;
    root.dataset.collectionInitialized = 'true';
    const cards = [...root.querySelectorAll('[data-archive-card]')];
    const grid = root.querySelector('[data-collection-grid]');
    const buttons = [...root.querySelectorAll('[data-collection-filter]')];
    const count = root.querySelector('[data-visible-count]');
    const empty = root.querySelector('[data-no-results]');
    const sort = root.querySelector('[data-collection-sort]');
    const params = new URL(window.location.href).searchParams;
    let active = params.get('filter') || 'all';

    const render = () => {
      let visible = cards.filter((card) => active === 'all' || card.dataset.filter === active);
      if (sort?.value === 'price-up') visible.sort((a, b) => Number(a.dataset.price) - Number(b.dataset.price));
      if (sort?.value === 'price-down') visible.sort((a, b) => Number(b.dataset.price) - Number(a.dataset.price));
      if (!sort || sort.value === 'default') visible.sort((a, b) => Number(a.dataset.order) - Number(b.dataset.order));
      cards.forEach((card) => { card.hidden = !visible.includes(card); });
      visible.forEach((card) => grid.appendChild(card));
      buttons.forEach((button) => button.classList.toggle('is-active', button.dataset.collectionFilter === active));
      count.textContent = visible.length;
      empty.hidden = visible.length > 0;
    };
    buttons.forEach((button) => button.addEventListener('click', () => {
      active = button.dataset.collectionFilter;
      const url = new URL(window.location.href);
      if (active === 'all') url.searchParams.delete('filter');
      else url.searchParams.set('filter', active);
      window.history.replaceState({}, '', url);
      render();
    }));
    sort?.addEventListener('change', render);
    render();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["audere-product"]) return;
  try {
    
  document.querySelectorAll('[data-audere-product]').forEach((root) => {
    if (root.dataset.productInitialized === 'true') return;
    root.dataset.productInitialized = 'true';

    const apparelButtons = [...root.querySelectorAll('[data-apparel-size]')];
    if (apparelButtons.length) {
      apparelButtons.forEach((button) => button.addEventListener('click', () => {
        apparelButtons.forEach((item) => {
          const selected = item === button;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        root.querySelector('[data-apparel-variant-input]').value = button.dataset.id;
        root.querySelector('[data-apparel-price]').textContent = button.dataset.price;
        root.querySelector('[data-apparel-add-text]').textContent = `${root.dataset.addLabel} — ${button.dataset.price}`;
        root.querySelector('[data-apparel-add]').disabled = button.dataset.available !== 'true';
        const url = new URL(window.location.href);
        url.searchParams.set('variant', button.dataset.id);
        window.history.replaceState({}, '', url);
      }));
      return;
    }

    const sizeButtons = [...root.querySelectorAll('[data-size-option]')];
    const frameButtons = [...root.querySelectorAll('[data-frame-option]')];
    if (!sizeButtons.length || !frameButtons.length) return;

    const variants = [...root.querySelectorAll('[data-audere-variant]')].map((element) => ({
      size: element.dataset.size,
      frame: element.dataset.frame,
      id: element.dataset.id,
      price: element.dataset.price,
      available: element.dataset.available === 'true',
    }));

    let size = sizeButtons.find((button) => button.classList.contains('is-selected'))?.dataset.sizeOption;
    let frame = frameButtons.find((button) => button.classList.contains('is-selected'))?.dataset.frameOption;

    const sync = () => {
      const variant = variants.find((item) => item.size === size && item.frame === frame);
      if (!variant) return;

      sizeButtons.forEach((button) => {
        const selected = button.dataset.sizeOption === size;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      frameButtons.forEach((button) => {
        const selected = button.dataset.frameOption === frame;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });

      const frameButton = frameButtons.find((button) => button.dataset.frameOption === frame);
      const preview = root.querySelector('[data-frame-preview]');
      if (preview && frameButton) {
        const frameKind = frameButton.dataset.frameKind || '';
        const overlayKind = frameKind.includes('frameless')
          ? ''
          : frameKind.includes('black')
            ? 'black'
            : frameKind.includes('alum')
              ? 'aluminum'
              : 'wood';

        preview.dataset.frameKind = frameKind;
        preview.querySelectorAll('[data-frame-overlay]').forEach((overlay) => {
          const isActive = overlay.dataset.frameOverlay === overlayKind;
          overlay.classList.toggle('is-active', isActive);
          overlay.style.opacity = isActive ? '1' : '0';
          overlay.style.visibility = isActive ? 'visible' : 'hidden';
        });
      }
      root.querySelector('[data-frame-label]').textContent = frame;
      root.querySelector('[data-size-dimension]').textContent = {
        A3: '297 × 420 mm',
        A2: '420 × 594 mm',
        A1: '594 × 841 mm',
      }[size] || size;
      root.querySelector('[data-variant-input]').value = variant.id;
      root.querySelector('[data-product-price]').textContent = variant.price;
      sizeButtons.forEach((button) => {
        const matchingVariant = variants.find((item) => item.size === button.dataset.sizeOption && item.frame === frame);
        const price = button.querySelector('.audere-format-option__price');
        if (price && matchingVariant) price.textContent = matchingVariant.price;
      });
      root.querySelector('[data-add-button-text]').textContent = `${root.dataset.addLabel} — ${variant.price}`;
      root.querySelector('[data-add-button]').disabled = !variant.available;

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };

    sizeButtons.forEach((button) => button.addEventListener('click', () => {
      size = button.dataset.sizeOption;
      sync();
    }));
    frameButtons.forEach((button) => button.addEventListener('click', () => {
      frame = button.dataset.frameOption;
      sync();
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
